import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function ConnectWithoutContactIcon(props: IconProps) {
    return <Icon {...props} iconKey={"connect_without_contact"}/>
}
